import { render, staticRenderFns } from "./VIPStar.vue?vue&type=template&id=4795406b&scoped=true&"
import script from "./VIPStar.vue?vue&type=script&lang=js&"
export * from "./VIPStar.vue?vue&type=script&lang=js&"
import style0 from "./VIPStar.vue?vue&type=style&index=0&id=4795406b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4795406b",
  null
  
)

export default component.exports